module.exports = __webpack_public_path__ + "img/certFblc.f745a143.jpg";